<template>
    <div>
        <div class="content-wrapper" v-if="!loadingComplete()">
            <section class="content">
                <div class="col-md-12">
                    <div class="box box-primary">
                        <div class="box-header">
                            <h3 class="box-title">Chargement en cours</h3>
                        </div>
                        <div class="box-body">
                            Chargement de la fiche du compte
                        </div>
                        <div class="overlay">
                            <i class="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <div class="content-wrapper" v-if="compte">
            <section class="content">
                <div class="row">
                    <ventilation>
                    </ventilation>
                </div>

                <div v-if="loadingComplete()" class="row">
                    <div class="col-md-4">
                        <div class="box box-widget widget-user-2">
                            <div class="widget-user-header bg-blue">
                                <div class="widget-user-image">
                                    <img class="" src="../../assets/img/bank-building.png" alt="User Avatar">
                                </div>
                                <h3 class="widget-user-username">{{ compte.proprietaire!=null ? compte.proprietaire.nom : "Inconnu" }}</h3>
                                <h5 class="widget-user-desc">{{ compte.iban }}</h5>
                            </div>
                            <div class="box-footer no-padding">
                                <ul class="nav nav-stacked">
                                    <li><a href="#"><strong>Opérations reçues </strong><span class="pull-right badge bg-blue">{{ compte.operations_recues.length }}</span></a></li>
                                    <li><a href="#">Montant des opérations reçues en {{ current_year() }}<span class="pull-right badge bg-green">{{  number_format(compte.total_operations_recues) }}€</span></a></li>
                                    <li><a href="#">Montant des opérations reçues en {{ current_year()-1 }}<span class="pull-right badge bg-gray">{{  number_format(compte.total_operations_recues_before_year) }}€</span></a></li>
                                    <li><a href="#"><strong>Opérations envoyées </strong> <span class="pull-right badge bg-blue">{{ compte.operations_envoyees.length }}</span></a></li>
                                    <li><a href="#">Montant des opérations envoyées en {{ current_year() }} <span class="pull-right badge bg-red">{{  number_format(compte.total_operations_envoyees) }}€</span></a></li>
                                    <li><a href="#">Montant des opérations envoyées en {{ current_year()-1 }} <span class="pull-right badge bg-gray">{{  number_format(compte.total_operations_envoyees_before_year) }}€</span></a></li>
                                </ul>
                            </div>
                        </div><!-- /.widget-user -->
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                        <div class="box box-primary">
                            <div class="box-header with-border">
                                <h3 class="box-title">Informations</h3>
                            </div><!-- /.box-header -->
                            <div class="box-body">
                                <dl class="dl-horizontal">
                                    <dt>Compte</dt>
                                    <dd>{{ compte.proprietaire!=null ? compte.proprietaire.nom : "Inconnu" }}</dd>
                                    <dt>Iban</dt>
                                    <dd>{{ compte.iban }}</dd>
                                    <dt>Adresse</dt>
                                    <dd>{{ compte.adresse ? compte.adresse : "Non-précisé" }}</dd>
                                    <dt>Ville</dt>
                                    <dd>{{ (compte.ville) ? compte.ville.cp+" "+compte.ville.name : "Non-précisé" }}</dd>
                                    <dt>Banque</dt>
                                    <dd>{{ compte.banque!=null ? compte.banque.banque : "Non-précisé" }} (BIC:{{compte.banque!=null ? compte.banque.bic ? compte.banque.bic : "Non-précisé" : "Non-précisé"}})</dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                        <div class="box box-primary">
                            <div class="box-header with-border">
                                <h3 class="box-title">Lier à un membre particulier
                                    <i class="fa fa-question-circle text-light-blue" data-html="true" data-toggle="tooltip" data-placement="right"
                                       title="Vous avez la possibilité de lier ce compte à une personne particulière. Cet usage est exclusivement interne au secrétariat et ne devrait servir que pour lier les comptes bancaires privés (pas les comptes des clubs)"></i>
                                </h3>
                            </div>
                            <div class="box-body">
                                <button class="btn btn-primary" data-toggle="modal" data-target="#LinkMemberModal">
                                    Lier un membre à ce compte
                                </button>
                                <!--<modal-link-member class="modal fade" id="LinkMemberModal" tabindex="-1" role="dialog" aria-labelledby="LinkMemberModal"-->
                                <!--title="Lier un  membre à ce compte"-->
                                <!--title-submit="Ajouter"-->
                                <!--:show-close-btn="true"-->
                                <!--:roles="{{roles}}"-->
                                <!--route-search-member="{{route('memberSearch') }}"-->
                                <!--route-click-on-item="{{route("linkMemberToCompte")}}"-->
                                <!--route-link-member="{{route("linkMemberToCompte")}}"-->
                                <!--:id-other="{{ compte.id }}"-->
                                <!--type-link="compte"-->
                                <!--&gt;-->
                                <!--</modal-link-member>-->
                                <hr/>
                                <!--<list-of-members-link-->
                                <!--:send-ajax="false"-->
                                <!--&gt;-->
                                <!--</list-of-members-link>-->

                                <!--<list-of-members-link-->
                                <!--link-on-remove="{{ route('removeMemberToCompte') }}"-->
                                <!--:id-other="{{ compte.id }}"-->
                                <!--:users="[ @if(sizeof($membresLies)>0) {{ json_encode($membresLies) }} @endif]"-->
                                <!--type-link="compte"-->
                                <!--&gt;-->
                                <!--</list-of-members-link>-->
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="loadingComplete()" id="searchAndVueTable">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="box">
                                <div class="box-header">
                                    <h3 class="box-title">Liste des opérations</h3>
                                </div>

                                <div class="box-body table-responsive no-padding">
                                    <vuetable
                                            ref="vuetable"
                                            :api-url="routeOperationIndex"
                                            :css="cssBootstrap"
                                            :fields="vueTableOperation.columns"
                                            :item-actions="vueTableOperation.itemActions"
                                            :per-page="perPage"
                                            :sort-order="vueTableOperation.sortOrder"
                                            :multi-sort="true"
                                            :render-icon="renderIcon"
                                            pagination-component="vuetable-pagination-bootstrap"
                                            wrapper-class="vuetable-wrapper"
                                            detail-row-component="detailrow"
                                            loading-class="loading"
                                            detail-row-id="id"
                                            detail-row-transition="expand"
                                            row-class-callback="rowClassCB"
                                            table-wrapper=".vuetable-wrapper"
                                            :append-params="{id_compte:id_compte}"
                                            @vuetable:pagination-data="onPaginationData"
                                            @vuetable:cell-clicked="onCellClicked"
                                            @vuetable:loading="loading"
                                            @vuetable:loaded="loaded"
                                    >
                                        <template slot="compte_de" slot-scope="props">
                                            <router-link v-if="props.rowData.compte_de && props.rowData.compte_de.proprietaire"
                                                         :to="{ name: 'Compte', params: { id_compte: props.rowData.compte_de.proprietaire.id }}">
                                                {{props.rowData.compte_de.proprietaire.nom}}
                                            </router-link>
                                        </template>
                                        <template slot="compte_vers" slot-scope="props">
                                            <router-link v-if="props.rowData.compte_vers && props.rowData.compte_vers.proprietaire"
                                                         :to="{ name: 'Compte', params: { id_compte: props.rowData.compte_vers.proprietaire.id }}">
                                                {{props.rowData.compte_vers.proprietaire.nom}}
                                            </router-link>
                                        </template>
                                        <template slot="actions" slot-scope="props">
                                            <div class="custom-actions">
                                                <button class="btn btn-default padding2"
                                                        @click="toggleDetailRow(props.rowData)">
                                                    <i class="glyphicon glyphicon-zoom-in"></i>
                                                </button>
                                                <button class="btn btn-warning padding2"
                                                        @click="ventilerItem(props.rowData)">
                                                    <i class="glyphicon glyphicon-random"></i>
                                                </button>
                                                <button class="btn btn-primary padding2"
                                                        v-if="dontShowIfVentille(props.rowData)"
                                                        @click="setInCompteAttente(props.rowData)">
                                                    <i class="glyphicon glyphicon-flash"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </vuetable>
                                    <vuetable-pagination
                                            ref="pagination"
                                            @vuetable-pagination:change-page="onChangePage"
                                    ></vuetable-pagination>
                                </div>

                            </div><!-- /.box -->
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>


<script type="text/babel">
    import Vue from 'vue'
    import {mapGetters, mapActions} from 'vuex'
    import vuetable from '../VueTable/Lib/Vuetable.vue'
    import BootstrapStyle from '../Communs/cssBootstrap-css'
    import detailrow from '../VueTable/Templates/RowDetailsOperations.vue'
    import ventilation from '../Operations/ventilation.vue'
    import vueTableOperation from '../VueTable/configs/vueTableOperation'
    import VuetablePagination from '../VueTable/Lib/VuetablePagination.vue'

    var moment = require('moment');
    var _ = require('underscore')
    var variables = require('../../assets/js/variables')

    Vue.component('detailrow', detailrow)

    export default {
        props: {
            id_compte: {
                required: true
            },
        },
        data() {
            return {
                compte: null,
                perPage: 25,
                routeOperationIndex: "",
                dataTableOperationsCompte: null,
                visibleDetailRows: [],
                vueTableOperation: vueTableOperation,
                cssBootstrap: BootstrapStyle,
            }
        },
        computed: {
            ...mapGetters({
                getSearchRequest: 'getSearchRequest',
                getSubmitToProcess: 'getSubmitToProcess',
                getLoadingTableOperation: 'getLoadingTableOperation',
                getRoute: 'getRoute'
            }),
        },
        components: {
            vuetable,
            VuetablePagination,
            ventilation
        },
        methods: {
            ...mapActions({
                majOperationSelected: "majOperationSelected",
                submitToProcess: "submitToProcess",
                majLoadingTableOperation: "majLoadingTableOperation",
                addVentilationFromOperationSelected: 'addVentilationFromOperationSelected',
                setRubriquesSorties: 'setRubriquesSorties',
                setRubriquesEntrees: 'setRubriquesEntrees',
                majOperationInSearchResults: 'majOperationInSearchResults'
            }),
            loadRubriquesEntreesSorties: function () {
                this.$http.get(this.getRoute('Comptabilite.getRubriquesEntreesSorties'))
                    .then((response) => {
                        this.setRubriquesEntrees(response.body['rubriquesEntrees'])
                        this.setRubriquesSorties(response.body['rubriquesSorties'])
                    }, (response) => {
                        this.setRubriquesEntrees(null)
                        this.setRubriquesSorties(null)
                    });
            },
            current_year: function () {
                return moment().year();
            },
            number_format: function (number) {
                return Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR'}).format(number);
            },
            loadCompte: function () {
                this.$http.get(this.getRoute('Comptabilite.getInfosCompte') + this.id_compte)
                    .then((response) => {
                        this.compte = response.body.compte
                    }, (response) => {
                        this.compte = null
                    });

            },
            formatDate: function (value, fmt) {
                if (value == null) return ''
                fmt = (typeof fmt == 'undefined') ? 'DD/MM/YYYY HH:mm' : fmt
                return moment(value, 'YYYY-MM-DD hh:mm:ss').format(fmt)
            },
            loadingComplete: function () {
                return this.compte != null
            },
            loading: function () {
                this.majLoadingTableOperation(true)
            },
            loaded: function () {
                this.majLoadingTableOperation(false)
            },
            renderIcon(classes, options) {
                return `<span class="${classes.join(' ')}"></span>`
            },
            onCellClicked(data, field, event) {
                this.$refs.vuetable.toggleDetailRow(data.id)
            },
            onPaginationData(paginationData) {
                this.$refs.pagination.setPaginationData(paginationData)
            },
            onChangePage(page) {
                this.$refs.vuetable.changePage(page)
            },
            toggleDetailRow: function (data) {
                this.$refs.vuetable.toggleDetailRow(data.id)
            },
            formatMontant: function (value) {
                return value > 0 ? "<span class='text-success'>" + value + "€</span>" : "<span class='text-danger'>" + value + "€</span>";
            },
            ventilation: function (resteVentilation) {
                if (resteVentilation.SommeVentilation != null) {
                    if (resteVentilation.SommeVentilation.toFixed(2) == Math.abs(resteVentilation.montant).toFixed(2))
                        return "<span class='label label-success'>Ventilée</span>"
                    else if (resteVentilation.SommeVentilation.toFixed(2) != Math.abs(resteVentilation.montant).toFixed(2) && resteVentilation.SommeVentilation.toFixed(2) > 0)
                        return "<span class='label label-warning'>Partielle</span>"
                    else
                        return "<span class='label label-danger'>A ventiler</span> "
                }
                else
                    return "<span class='label label-danger'>A ventiler</span>"
            },
            ventilerItem: function (item) {
                this.majOperationSelected(item)
                $('#ventilationModal').modal()
            },
            dontShowIfVentille: function (item) {
                if (item.reste_ventilation.SommeVentilation != null) {
                    if (item.reste_ventilation.SommeVentilation.toFixed(2) == Math.abs(item.reste_ventilation.montant).toFixed(2))
                        return false
                    else if (item.reste_ventilation.SommeVentilation.toFixed(2) != Math.abs(item.reste_ventilation.montant).toFixed(2) && item.reste_ventilation.SommeVentilation.toFixed(2) > 0)
                        return false
                    else
                        return true
                }
                else
                    return true
            },
            setSelectedInCompteAttente: function () {
                var self = this
                this.itemProcessed = 0;
                var wrapper = document.querySelector(this.tableWrapper)
//                self.showLoadingAnimation(wrapper)
                this.$refs.vuetable.selectedTo.forEach(function (item, index, array) {
                    self.setInCompteAttente(item, true)
                })
            },
            setInCompteAttente: function (data, waitToHideLoadingAnimation = false) {
                var operation = data
                this.totalToProcess = this.$refs.vuetable.selectedTo.length

                var params = {}
                params.idOperation = operation.id
                params.idRubrique = -1
                params.montant = Math.abs(operation.montant)

                var self = this
                //GetRubrique
                this.$http.post(self.getRoute('getCompteAttente'), {entree: operation.entree}).then(function (response) {
                    params.idRubrique = response.data.rubrique.id
                    //XHR
                    this.$http.post(self.getRoute('addVentilation'), params).then(function (response) {
                        this.majOperationSelected(data)
                        self.$noty.success(response.data.message)
                        this.addVentilationFromOperationSelected(response.data.ventilation)
                        this.majOperationInSearchResults(this.operationSelected)
                        self.totalToProcess--
                        var index = _.findIndex(this.$refs.vuetable.selectedTo, {operation})
                        this.$refs.vuetable.selectedTo.splice(index, 1)
                        return true
                    }, function (response) {
                        self.$noty.error("response.data.message")
                        self.totalToProcess--
                        return false
                    })
                })
            }
        },
        watch: {
            compte: function (value) {
                //Si pas de timeout, erreur d'instanciation pour $refs
                setTimeout(() => {
                    this.$refs.vuetable.refresh()
                    // this.submitToProcess(false)
                },250)
            },
            perPage: function (value) {
                this.perPage = parseInt(value)
                this.$nextTick(() => this.$refs.vuetable.refresh())
            },
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.routeOperationIndex = vm.getRoute("Comptabilite.operationsIndexPost");
                vm.loadRubriquesEntreesSorties();
                vm.loadCompte()
            })
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Operations/Compte.vue